<template>
<div id="home">

  <vue-headful
    title="Designbox"
    description="Designbox"
/>

  <section class="section warning" style="background-color:#ffa500;" v-show="getLoginPossibleText.length > 0">
    <div class="container">
        <div class="columns">
            <div class="column">
              <p v-html="getLoginPossibleText"></p>
            </div>
        </div>
    </div>
  </section>
  <section class="hero">
    <div class="hero-body">
      <LoginBox :redirect="working" />
    </div>
  </section>
</div>
</template>

<script>

import HomeBase from '@/components/HomeBase';
import LoginBox from './LoginBox';

export default {
    name:'Home',
    extends: HomeBase,
    components: { LoginBox },
    mounted () {
        const ua   = window.navigator.userAgent
        const msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            this.$router.push ({ name : "use-other-browser"})
        }
    }
}
</script>

<style>

.about{
  background-color: #057989;
  padding-top:80px;
  padding-bottom:80px;
  color:#fff!important;
}

.hero-title{
    font-weight:bold;
    font-size:50px;
}
.hero{
    background-image:url(./assets/img/kitchen.jpg);
    background-position: center center;
    background-repeat:  no-repeat;
    background-size:  inherit;
    background-color: #999;
}

.contact{
    background-image:url(./assets/img/contact.jpg);
    background-position: center center;
    background-repeat:  no-repeat;
    background-size:  inherit;
    background-color: #999;
}

.contact-container{
  background-color:#fff;
  padding-left:35px;
  padding-right:35px;
  padding-top:35px;
  padding-bottom: 35px;
}

.showcase{
  margin-top:55px;
  margin-bottom:55px;
}

.box{
  background: rgba(255,255,255,0.9);
padding: 30px;
-webkit-box-shadow: 0 1px 2px rgba(0,0,0,0.15);
-moz-box-shadow: 0 1px 2px rgba(0,0,0,0.15);
box-shadow: 0 1px 2px rgba(0,0,0,0.15);
-webkit-border-radius: 5px;
-moz-border-radius: 5px;
-ms-border-radius: 5px;
-o-border-radius: 5px;
border-radius: 5px;
}
</style>
